var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialXActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5922 21.384C19.5169 21.5212 19.4061 21.6357 19.2714 21.7156C19.1368 21.7954 18.9832 21.8376 18.8266 21.8379H13.5766C13.4293 21.8378 13.2845 21.8006 13.1554 21.7297C13.0264 21.6588 12.9173 21.5564 12.8383 21.4321L8.40972 14.4726L1.9741 21.5513C1.81721 21.7199 1.60023 21.8198 1.37018 21.8294C1.14013 21.839 0.915568 21.7575 0.745173 21.6027C0.574778 21.4478 0.472286 21.232 0.459917 21.0021C0.447548 20.7722 0.526299 20.5467 0.679098 20.3745L7.43519 12.937L0.588316 2.1832C0.50399 2.05091 0.456784 1.89837 0.451642 1.74157C0.4465 1.58477 0.483611 1.42947 0.559088 1.29193C0.634566 1.15439 0.745634 1.03968 0.880662 0.9598C1.01569 0.879921 1.16971 0.837814 1.3266 0.837891H6.5766C6.72386 0.837936 6.86873 0.875149 6.99779 0.946082C7.12684 1.01701 7.23591 1.11937 7.31488 1.24367L11.7435 8.2032L18.1791 1.12445C18.336 0.955927 18.553 0.856029 18.783 0.846417C19.0131 0.836806 19.2376 0.918256 19.408 1.07311C19.5784 1.22796 19.6809 1.44373 19.6933 1.67365C19.7056 1.90356 19.6269 2.12909 19.4741 2.30133L12.718 9.73336L19.5649 20.4937C19.6487 20.626 19.6955 20.7785 19.7003 20.9351C19.7051 21.0917 19.6678 21.2467 19.5922 21.384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialXActive);
export default __webpack_public_path__ + "static/media/social_x_active.88548571265bbe7ca2559ecbf5c6af36.svg";
export { ForwardRef as ReactComponent };